<template>
    <div class="public-data">
        <b-row>
            <!--
            <b-col cols="2">
                <b-badge variant="light" v-b-toggle="'public-data-'+_uid">
                    Informazioni pubbliche
                </b-badge>
            </b-col>
            -->
            <b-col cols="12">
                <!--<b-collapse :id="'public-data-'+_uid">-->
                    <b-row>
                        <b-col md="2">
                            <div class="public-data--price">
                                <b-form-group id="public_price" label="Prezzo pubblico" label-for="public_price">
                                    <b-form-input
                                        type="number"
                                        min="0"
                                        size="sm"
                                        id="public_price"
                                        v-model="public_price"
                                        placeholder="prezzo di vendita"
                                        required
                                        @input="update_public_data"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                        </b-col>
                        <b-col md="3">
                            <div class="public-data--notes">
                                <b-form-group id="agent_notes">
                                    <tiny-mce
                                        :preview_mode="true"
                                        :height="400"
                                        :block_title="'Dal tuo consulente'"
                                        :initial_value="this.agent_notes"
                                        @input="(value) => {
                                            this.agent_notes = value
                                            this.update_public_data()
                                        }"
                                    />
                                </b-form-group>
                            </div>
                        </b-col>
                        <b-col md="3">
                            <div class="public-data--notes">
                              <b-form-group id="service_notes">
                                <tiny-mce
                                    :preview_mode="true"
                                    :height="400"
                                    :block_title="'Soluzione in dettaglio'"
                                    :initial_value="this.service_notes"
                                    @input="(value) => {
                                        this.service_notes = value
                                        this.update_public_data()
                                    }"
                                />
                              </b-form-group>
                            </div>
                        </b-col>
                        <b-col md="3">
                            <div class="public-data--notes">
                              <b-form-group id="public_notes">
                                <tiny-mce
                                    :preview_mode="true"
                                    :height="400"
                                    :block_title="'Note istruzioni condizioni'"
                                    :initial_value="this.public_notes"
                                    @input="(value) => {
                                        this.public_notes = value
                                        this.update_public_data()
                                    }"
                                />
                              </b-form-group>
                            </div>
                        </b-col>
                    </b-row>
                <!--</b-collapse>-->
            </b-col>
        </b-row>
    </div>
</template>

<script>
import TinyMce from '@/components/blocks/tiny-mce'
export default {
    name: 'public-data',
    components: {
        'tiny-mce': TinyMce
    },
    props: {
        public_data: {
            type: Object,
            default: () => {}
        },
        service_index: Number,
    },
    data() {
        return {
            public_price: this.public_data.public_price,
            agent_notes: this.public_data.agent_notes, // dal tuo consulente
            service_notes: this.public_data.service_notes, // la soluzione in dettaglio
            public_notes: this.public_data.public_notes, // note termini e condizioni
            links: this.public_data.links,
        }
    },
    created()
    {
    },
    mounted() {
    },
    methods:{
        update_public_data()
        {
            this.$store.commit('set_service_public_data', {
                service_index: this.service_index,
                public_data: {
                    public_price: this.public_price,
                    agent_notes: this.agent_notes,
                    service_notes: this.service_notes,
                    public_notes: this.public_notes,
                    links: this.links,
                },
            })
            //this.$store.dispatch('update_quote_grand_total')
        },
    },
    computed: {
    }
}
</script>

<style lang="scss">
    .public-data
    {
        //@extend .service--common--block !optional;
        &--item
        {
        }
        &--links
        {
        }
        &--notes
        {
        }
        &--price
        {
        }
        &--links--title
        {
        }
        &--link
        {
        }
    }
</style>